import React, { useState, useRef } from "react";
import PageTitle from "../../components/PageTitle";
import CouponListTable from "./components/CouponListTable";
import {
  Grid,
  Paper,
  InputBase,
  IconButton,
} from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import Widget from "../../components/Widget";

import styled, { keyframes } from "styled-components";
import P from "../../styled-components/planStyle"
import { Btn } from "../../styled-components/basicStyle"

import { Link } from "react-router-dom";

function Plan(){
  //pagination 변수들: 받아오는 리스트, 나열할 리스트, 페이지
  const [searchInput, setSearchInput] = useState('');
  const [planFilter, setPlanFilter] = useState("all");
  const excelRef = useRef(null);
  const [excelMeta, setExcelMeta] = useState({
    isExcelLoading: false,
    activeCount: 0,
    disabled: true,
  });

  // 세부 행 관리
  const getValue = (e) => {
    setSearchInput(e.target.value)
  }

  return (
    <>
      <PageTitle title="플랜 관리" />
      <P.HandleDiv>
        <SearchArea>
          <SearchPaper
            component="form"
            sx={{ display: "flex", alignItems: "center", width: "400" }}
          >
            <IconButton type="button" aria-label="search">
              <SearchIcon />
            </IconButton>
            <SearchInput
              placeholder="Search"
              inputProps={{ "aria-label": "Search" }}
              onChange={getValue}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
          </SearchPaper>
          <FilterSwitch role="tablist" aria-label="플랜 상태 필터">
            <FilterOption
              type="button"
              $active={planFilter === "all"}
              onClick={() => setPlanFilter("all")}
            >
              전체
            </FilterOption>
            <FilterOption
              type="button"
              $active={planFilter === "active"}
              onClick={() => setPlanFilter("active")}
            >
              유효한 플랜
            </FilterOption>
            <FilterOption
              type="button"
              $active={planFilter === "ended"}
              onClick={() => setPlanFilter("ended")}
            >
              지난 플랜
            </FilterOption>
          </FilterSwitch>
        </SearchArea>
        <HeaderActions>
          <DownloadAction>
            <ExcelBtn
              type="button"
              disabled={excelMeta.disabled}
              onClick={() => excelRef.current?.downloadExcel()?.catch((error) => {
                console.error("엑셀 다운로드 실패:", error);
                alert("엑셀 다운로드 중 오류가 발생했습니다.");
              })}
            >
              {excelMeta.isExcelLoading ? (
                <>
                  <Spinner />
                  엑셀 생성 중
                </>
              ) : (
                <>
                  플랜 회원 정보 다운로드
                  <CountBadge>excel</CountBadge>
                </>
              )}
            </ExcelBtn>
            <DownloadHint>
              현재 유효한 플랜을 이용 중인<br/>회원 정보를 엑셀 파일로 저장합니다.
            </DownloadHint>
          </DownloadAction>
          <Link to="/app/researchAll/plan/createPlan">
            <CreateBtn>플랜 생성</CreateBtn>
          </Link>
        </HeaderActions>
      </P.HandleDiv>
      <Grid item xs={12}>
        <Widget>
          <CouponListTable
            ref={excelRef}
            filterKeyword={searchInput}
            planFilter={planFilter}
            onExcelMeta={setExcelMeta}
          />
        </Widget>
      </Grid>
    </>
  );
}

export default Plan;

const SearchInput = styled(InputBase)`
    display: inline-flex;
    margin-top: 10px;
    width: 80%;
`
const SearchPaper = styled(Paper)`
    width: 250px;
`

const SearchArea = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
`

const FilterSwitch = styled.div`
    display: inline-flex;
    align-items: stretch;
    height: 50px;
    box-sizing: border-box;
    padding: 4px;
    background: #eef1f7;
    border-radius: 6px;
    gap: 2px;
`

const FilterOption = styled.button`
    border: none;
    background: ${({ $active }) => ($active ? "#ffffff" : "transparent")};
    color: ${({ $active }) => ($active ? "#536DFE" : "#7b8194")};
    box-shadow: ${({ $active }) => ($active ? "0 1px 4px rgba(15, 23, 42, 0.1)" : "none")};
    padding: 0 14px;
    border-radius: 5px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: -0.2px;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;

    &:hover {
        color: ${({ $active }) => ($active ? "#536DFE" : "#4a4f63")};
    }
`

const HeaderActions = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`

const DownloadAction = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: stretch;
`

const ExcelBtn = styled(Btn)`
    width: 230px;
    padding: 0;
    background-color: #38761D;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    box-shadow: 0 3px 8px rgba(56, 118, 29, 0.35);

    &:hover {
        background-color: #2e5c16;
        box-shadow: 0 5px 12px rgba(56, 118, 29, 0.42);
    }

    &:disabled {
        background-color: #9aa0a6;
        box-shadow: none;
        cursor: not-allowed;
        opacity: 1;
    }
`

const CreateBtn = styled(Btn)`
    box-shadow: 0 3px 8px rgba(83, 109, 254, 0.35);

    &:hover {
        box-shadow: 0 5px 12px rgba(83, 109, 254, 0.42);
    }
`

const CountBadge = styled.span`
    min-width: 28px;
    height: 22px;
    padding: 0 7px;
    border-radius: 11px;
    background: rgba(255, 255, 255, 0.2);
    font-size: 12px;
    font-weight: 600;
    line-height: 22px;
    text-align: center;
`

const DownloadHint = styled.p`
    width: 0;
    min-width: 100%;
    margin: 8px 2px 0;
    font-size: 12px;
    line-height: 1.45;
    color: #8b8b8b;
    text-align: center;
    word-break: keep-all;
`

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`

const Spinner = styled.span`
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.35);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: ${spin} 0.8s linear infinite;
    flex-shrink: 0;
`
